import { Component, createRef } from 'react';
import TuiImageEditor from 'tui-image-editor';
import type { F } from 'ts-toolbelt';

import { EMPTY_STRING } from '@e-socna/empty';

export class ImageEditor extends Component<tuiImageEditor.IOptions> {
  private readonly rootEl = createRef<HTMLDivElement>();

  private imageEditorInst: TuiImageEditor | null = null;

  override componentDidMount() {
    if (!this.rootEl.current) {
      return;
    }

    this.imageEditorInst = new TuiImageEditor(this.rootEl.current, this.props);

    this.bindEventHandlers(this.props);
  }

  override componentWillUnmount() {
    this.unbindEventHandlers();

    this.imageEditorInst?.destroy();

    this.imageEditorInst = null;
  }

  override shouldComponentUpdate(nextProps: tuiImageEditor.IOptions) {
    this.bindEventHandlers(this.props, nextProps);

    return false;
  }

  getInstance() {
    return this.imageEditorInst;
  }

  getRootElement() {
    return this.rootEl.current;
  }

  bindEventHandlers(
    props: tuiImageEditor.IOptions,
    prevProps?: tuiImageEditor.IOptions,
  ) {
    Object.keys(props)
      .filter(this.isEventHandlerKeys)
      .forEach((key) => {
        const eventName = `${key[2]?.toLowerCase() ?? EMPTY_STRING}${key.slice(3)}`;
        // For <ImageEditor onFocus={condition ? onFocus1 : onFocus2} />
        if (
          prevProps?.[key as keyof tuiImageEditor.IOptions] !==
            props[key as keyof tuiImageEditor.IOptions] &&
          this.imageEditorInst &&
          'off' in this.imageEditorInst &&
          typeof this.imageEditorInst.off === 'function'
        ) {
          try {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            this.imageEditorInst.off(eventName);
          } catch (e) {
            console.error(e);
          }
        }
        this.imageEditorInst?.on(
          eventName,
          props[key as keyof tuiImageEditor.IOptions] as F.Function,
        );
      });
  }

  unbindEventHandlers() {
    Object.keys(this.props)
      .filter(this.isEventHandlerKeys)
      .forEach((key) => {
        const eventName = `${key[2]?.toLowerCase() ?? EMPTY_STRING}${key.slice(3)}`;

        if (
          this.imageEditorInst &&
          'off' in this.imageEditorInst &&
          typeof this.imageEditorInst.off === 'function'
        ) {
          try {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            this.imageEditorInst.off(eventName);
          } catch (e) {
            console.error(e);
          }
        }
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  isEventHandlerKeys(this: void, key: string) {
    return /on[A-Z][a-zA-Z]+/.test(key);
  }

  override render() {
    return <div ref={this.rootEl} />;
  }
}
